module.exports = __webpack_public_path__ + "img/img_product12.97d18afc.png";